import { HttpClient, HttpMethods } from "../types/httpClient";
import { TagsScope } from "@planzone/dto";

function getProjectsElementsTags(httpClient: HttpClient) {
  return (scope?: TagsScope, scopeId?: string) => {
    return httpClient
      .sendHttpRequest<{ tags: string[] }>({
        endpoint: "/projects/elements/tags",
        method: HttpMethods.POST,
        data: {
          ...(scope && { scope }),
          ...(scopeId && { scopeId }),
        },
      })
      .then(({ tags }) => tags.map((name) => ({ name })));
  };
}

export { getProjectsElementsTags };
